import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Map, Marker, GoogleApiWrapper, InfoWindow } from 'google-maps-react';
import { Svg, Images } from 'assets';
import { mapStyles } from '../../eventDetails/fragments/constants';
import { TextRow } from 'components';
import { EventTimeConvertor } from '../../../utils/hooks/eventTimeConvertor';
import { sortEventsByDateTimeAsc } from './constants';

const EventMapView = (props) => {
    const allEvents = useSelector((state) => state.events.events);
    const [showInfoWindow, setShowInfoWindow] = useState(false);
    const [activeMarker, setActiveMarker] = useState(null);
    const [event, setEvent] = useState(null);
    const [currentLocation, setCurrentLocation] = useState({
        lat: 40.712776, // default NY coords
        lng: -74.005974
    });
    const sortedEvents = sortEventsByDateTimeAsc(allEvents?.events);
    const eventImage = event?.images?.length > 0 ? event.images[event.eventImage ? event.eventImage : 0].url : Images.EventImage;

    const mapStyle = {
        width: '100%',
        height: '1000px',
        position: 'relative',
    };

    useEffect(() => {
        // Attempt to get user's location
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(
                (position) => {
                    setCurrentLocation({
                        lat: position.coords.latitude,
                        lng: position.coords.longitude
                    });
                },
                (error) => {
                    console.warn("Geolocation permission denied or unavailable, using default location.");
                    // Keep the default location
                }
            );
        } else {
            console.warn("Geolocation not supported by this browser.");
        }
    }, []);

    const onMarkerClick = (props, marker, item) => {
        setEvent(item);
        setActiveMarker(marker);
        setShowInfoWindow(true);
    };

    const onClose = () => {
        if (showInfoWindow) {
            setShowInfoWindow(false);
            setActiveMarker(null);
        }
    };

    return (
        <div className="events-page-map-view">
            <div className="event-map-view-section">
                <Map
                    google={props.google}
                    zoom={14}
                    styles={mapStyles}
                    style={mapStyle}
                    initialCenter={currentLocation}
                    containerStyle={mapStyle}
                    streetViewControl={false}
                    fullscreenControl={false}
                    mapTypeControl={false}
                    center={currentLocation}
                    onClick={onClose}
                >
                    {sortedEvents?.map(
                        (i) =>
                            i?.address?.lat && (
                                <Marker
                                    onClick={(props, marker) => onMarkerClick(props, marker, i)}
                                    position={{
                                        lat: i.address.lat,
                                        lng: i.address.lng,
                                    }}
                                    icon={Svg.MapMarker}
                                    key={i?.id}
                                />
                            )
                    )}

                    <InfoWindow marker={activeMarker} visible={showInfoWindow} onClose={onClose}>
                        <div className="map-event-wrapper">
                            <div className="map-event-image-box" style={{ backgroundImage: `url(${eventImage})` }}>
                                <div className="map-event-type-box">
                                    <div className="event-type">{event?.locationType === 'VIRTUAL' ? 'ONLINE' : 'IN-PERSON'}</div>
                                </div>
                                <button
                                    className="close-map-btn"
                                    onClick={() => {
                                        setShowInfoWindow(false);
                                        setActiveMarker(null);
                                    }}>
                                    <Svg.Close />
                                </button>
                            </div>
                            <div className="map-event-information-box">
                                <div className="map-event-title">
                                    <TextRow name={event?.title} />
                                </div>
                                <div className="map-event-date-time-location-box">
                                    <div className="map-event-info-box">
                                        <div className="icon-box">
                                            <Svg.EventCalendar />
                                        </div>


                                        <EventTimeConvertor event={event}/>
                                        {/*{event?.timezoneOffset ? (*/}
                                        {/*    <div>*/}
                                        {/*        {event?.locationType === 'VIRTUAL' ? (*/}
                                        {/*            <p>*/}
                                        {/*                {event?.startTime ?*/}
                                        {/*                    `${originalDateConverter(event)} ${event.timezoneOffset ? `(GMT ${event.timezoneOffset} )` : ''}`*/}
                                        {/*                    : `${moment(event.startDate).format('MM/DD/YYYY')}`}*/}
                                        {/*            </p>*/}
                                        {/*        ) : (*/}
                                        {/*            <p>*/}
                                        {/*                {event.startTime*/}
                                        {/*                    ? `${dateConverter(event)} (Your Time)`*/}
                                        {/*                    : `${moment(event.startDate).format('MM/DD/YYYY')}`}*/}
                                        {/*            </p>*/}
                                        {/*        )}*/}
                                        {/*    </div>*/}
                                        {/*) : (*/}
                                        {/*    <p>{`${moment(event?.startTime).format('llll')} ${*/}
                                        {/*        event?.timezoneOffset ? `(GMT ${event?.timezoneOffset} )` : ''*/}
                                        {/*    }`}</p>*/}
                                        {/*)}*/}
                                    </div>
                                    {event?.address?.formattedAddress && (
                                        <div className="map-event-info-box">
                                            <div className="icon-box">
                                                <Svg.EventLocation />
                                            </div>
                                            <TextRow name={event?.address?.formattedAddress} textWidth={8} />
                                        </div>
                                    )}
                                </div>

                                <a
                                    className="map-event-view-details-btn"
                                    href={`/event/${event?.eventId}`}
                                    rel='noopener'
                                    target={'_blank'}
                                >
                                    <p className="map-view-details-btn-text">View Details</p>
                                    <Svg.ArrowUpRight />
                                </a>
                            </div>
                        </div>
                    </InfoWindow>
                </Map>
            </div>
        </div>
    );
};

export default GoogleApiWrapper({
    apiKey: process.env.REACT_APP_GOOGLE_API_KEY,
})(EventMapView);
